export const INIT_CREATE = 'groupCreationWizard/INIT_CREATE';
export const INIT_EDIT = 'groupCreationWizard/INIT_EDIT';
export const SET_STEP = 'groupCreationWizard/SET_STEP';
export const PATCH = 'groupCreationWizard/PATCH';
export const RESET = 'groupCreationWizard/RESET';

const initialState = {
  initialized: false,
  mode: 'create',
  activeStep: 1,
  code: '',
  userType: 'internal',
  groupId: null,
  filterString: '',
  sortModel: {},
  manualUserIds: [],
  conditionalAllUsers: false,
  hydrated: false
};

const groupCreationWizard = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return { ...initialState };
    case INIT_CREATE:
      return {
        ...initialState,
        initialized: true,
        mode: 'create',
        userType: action.payload?.userType ?? 'internal',
        code: (action.payload?.code || '').trim()
      };
    case INIT_EDIT: {
      return {
        ...initialState,
        initialized: true,
        mode: 'edit',
        groupId: action.payload?.groupId || null,
        userType: action.payload?.userType ?? null,
        hydrated: false
      };
    }
    case SET_STEP:
      return { ...state, activeStep: action.payload };
    case PATCH:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default groupCreationWizard;
